<template>
  <block-template
    :data="data"
    title="Подзаголовок"
    :possible-next="possibleNext"
    :is-last="isLast"
  >
    <h2>{{ data.content }}</h2>
  </block-template>
</template>

<script>
import BlockTemplate from "./Template";
export default {
  name: "BlockSubtitle",
  components: { BlockTemplate },
  props: {
    data: {
      type: Object,
      required: true,
      content: {
        type: String,
        required: true
      },
      parent_type: {
        type: String,
        required: true
      },
      parent_id: {
        type: Number,
        required: true
      }
    },
    possibleNext: {
      type: Object,
      required: true
    },
    isLast: {
      type: Boolean,
      default: false
    }
  }
};
</script>
